// Set de línea MBM · 24px / stroke 1.6 · sin emojis
import React from 'react';

const Svg = ({ children, size = 24, color = 'currentColor', className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const IconCar = (p) => (
  <Svg {...p}>
    <path d="M4 12.5 5.8 8a2 2 0 0 1 1.9-1.3h8.6A2 2 0 0 1 18.2 8l1.8 4.5" />
    <path d="M3 12.5h18v4h-2.2M3 16.5v-4" />
    <path d="M3 16.5h2.2M9.4 16.5h5.2M18.8 16.5H21" />
    <circle cx="7.2" cy="16.5" r="1.7" />
    <circle cx="16.8" cy="16.5" r="1.7" />
  </Svg>
);

export const IconSearch = (p) => (
  <Svg {...p}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="m20 20-4.2-4.2" />
  </Svg>
);

export const IconHome = (p) => (
  <Svg {...p}>
    <path d="M4 11 12 4l8 7" />
    <path d="M6 9.5V20h12V9.5" />
    <path d="M10 20v-6h4v6" />
  </Svg>
);

export const IconQuake = (p) => (
  <Svg {...p}>
    <path d="M5 21V5l6-2v18" />
    <path d="M11 7h8v14h-8" />
    <path d="M13 10h2M13 13.5h2M13 17h2" />
    <path d="M7.5 8 9 10.5 7.5 13 9 15.5" />
    <path d="M3 21h18" />
  </Svg>
);

export const IconBaby = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="7.5" r="3" />
    <path d="M6.5 20c.6-3.4 2.8-5.2 5.5-5.2s4.9 1.8 5.5 5.2" />
    <path d="M12 14.8v2.4" />
  </Svg>
);

export const IconBriefcase = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="8" width="17" height="11.5" rx="2" />
    <path d="M9 8V6.4A1.9 1.9 0 0 1 10.9 4.5h2.2A1.9 1.9 0 0 1 15 6.4V8" />
    <path d="M3.5 12.5h17" />
  </Svg>
);

export const IconAdvisor = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="3.2" />
    <path d="M6 20c.7-3.6 3-5.4 6-5.4s5.3 1.8 6 5.4" />
    <path d="M18.6 9.5a6.6 6.6 0 0 1 .4 2.3c0 1.2-.3 2.2-.9 3" />
    <circle cx="18.6" cy="16.4" r="1.2" fill={p.color || 'currentColor'} stroke="none" />
  </Svg>
);

export const IconPhone = (p) => (
  <Svg {...p}>
    <path d="M6.5 4.5h3l1.2 3.2-1.8 1.4a11 11 0 0 0 5 5l1.4-1.8 3.2 1.2v3c0 1-.8 1.8-1.8 1.7A14.5 14.5 0 0 1 4.8 6.3C4.7 5.3 5.5 4.5 6.5 4.5Z" />
  </Svg>
);


export const IconDoc = (p) => (
  <Svg {...p}>
    <path d="M6 3.5h8L19 8.5V20.5H6z" />
    <path d="M14 3.5V8.5h5" />
    <path d="M9 12.5h6M9 15.7h6" />
  </Svg>
);

export const IconCheck = (p) => (
  <Svg {...p}>
    <path d="m5 12.5 4.5 4.5L19 7.5" />
  </Svg>
);

export const IconShield = (p) => (
  <Svg {...p}>
    <path d="M12 3.5 5 6v5.5c0 4.2 2.8 7.4 7 9 4.2-1.6 7-4.8 7-9V6z" />
    <path d="m9 11.5 2.2 2.2 3.8-3.9" />
  </Svg>
);

export const IconArrowRight = (p) => (
  <Svg {...p}>
    <path d="M4.5 12h15M13.5 6l6 6-6 6" />
  </Svg>
);

export const IconClip = (p) => (
  <Svg {...p}>
    <path d="m8 12.5 6-6a3 3 0 0 1 4.3 4.3l-7.5 7.5a4.6 4.6 0 0 1-6.5-6.5l6.8-6.8" />
  </Svg>
);

export const IconPlay = (p) => (
  <Svg {...p}>
    <path d="M7 5.5v13l11-6.5z" />
  </Svg>
);

export const IconReset = (p) => (
  <Svg {...p}>
    <path d="M4.5 8A8 8 0 1 1 4 13.5" />
    <path d="M4.5 3.5V8H9" />
  </Svg>
);

export const IconSpark = (p) => (
  <Svg {...p} color="#E40C0C">
    <path d="M12 4v4M12 16v4M4 12h4M16 12h4" />
  </Svg>
);

export const IconDownload = (p) => (
  <Svg {...p}>
    <path d="M12 4v10.5M7.5 10.5 12 15l4.5-4.5" />
    <path d="M4.5 19.5h15" />
  </Svg>
);

export const IconCopy = (p) => (
  <Svg {...p}>
    <rect x="8.5" y="8.5" width="11" height="11" rx="2" />
    <path d="M15.5 5.5v-1a2 2 0 0 0-2-2h-9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h1" transform="translate(2.5 1.5)" />
  </Svg>
);

export const IconChat = (p) => (
  <Svg {...p}>
    <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7a2.5 2.5 0 0 1-2.5 2.5H9l-5 4z" />
    <path d="M8 9.5h8M8 12.5h5" />
  </Svg>
);

export const IconShrug = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="6.5" r="2.6" />
    <path d="M7 20c.4-2.6 1.6-4.4 3-5" />
    <path d="M17 20c-.4-2.6-1.6-4.4-3-5" />
    <path d="M9 12.5 6 10.5M15 12.5l3-2" />
    <path d="M4 9.5 6 10.5M20 9.5l-2 1" />
  </Svg>
);

export const IconHealth = (p) => (
  <Svg {...p}>
    <path d="M12 20S4 14.5 4 9a4 4 0 0 1 8-1 4 4 0 0 1 8 1c0 5.5-8 11-8 11Z" />
    <path d="M8.5 11h2l1-2 1.5 4 1-2h1.5" />
  </Svg>
);

export const IconIncome = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="6.5" width="17" height="11" rx="2" />
    <circle cx="12" cy="12" r="2.6" />
    <path d="M6.5 9.5v5M17.5 9.5v5" />
  </Svg>
);

export const IconEdu = (p) => (
  <Svg {...p}>
    <path d="M3 9.5 12 5l9 4.5-9 4.5z" />
    <path d="M7 11.5v4.2c0 1.3 2.2 2.8 5 2.8s5-1.5 5-2.8v-4.2" />
    <path d="M21 9.5v5" />
  </Svg>
);

export const IconDevice = (p) => (
  <Svg {...p}>
    <rect x="7.5" y="3.5" width="9" height="17" rx="2.2" />
    <path d="M11 17.5h2" />
  </Svg>
);

export const IconSelf = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="3.2" />
    <path d="M6 20c.7-3.6 3-5.4 6-5.4s5.3 1.8 6 5.4" />
  </Svg>
);

export const IconCouple = (p) => (
  <Svg {...p}>
    <circle cx="8.5" cy="8" r="2.6" />
    <circle cx="15.5" cy="8" r="2.6" />
    <path d="M4 19c.5-2.9 2.2-4.4 4.5-4.4s4 1.5 4.5 4.4" />
    <path d="M15.5 14.6c2.3 0 4 1.5 4.5 4.4" />
  </Svg>
);

export const IconKids = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8.5" r="2.4" />
    <circle cx="16" cy="10" r="1.9" />
    <path d="M5 19c.4-2.6 2-4 4-4s3.6 1.4 4 4" />
    <path d="M13.5 19c.3-1.9 1.4-3 2.5-3s2.2 1.1 2.5 3" />
  </Svg>
);

export const IconParents = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="7.5" r="3" />
    <path d="M6.5 20c.5-3.3 2.7-5 5.5-5s5 1.7 5.5 5" />
    <path d="M9.5 7.5h5" />
  </Svg>
);

export const IconBank = (p) => (
  <Svg {...p}>
    <path d="M4 9.5 12 4l8 5.5" />
    <path d="M5 9.5h14" />
    <path d="M6.5 11v6M10 11v6M14 11v6M17.5 11v6" />
    <path d="M4.5 19.5h15" />
  </Svg>
);

export const IconCard = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="6" width="17" height="12" rx="2.2" />
    <path d="M3.5 10h17M6.5 14.5h4" />
  </Svg>
);

export const IconBuilding = (p) => (
  <Svg {...p}>
    <rect x="5.5" y="3.5" width="13" height="17" rx="1.6" />
    <path d="M9 7h2M13 7h2M9 10.5h2M13 10.5h2M9 14h2M13 14h2" />
    <path d="M10.5 20.5v-3h3v3" />
  </Svg>
);

export const IconUnknown = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M9.6 9.8a2.4 2.4 0 0 1 4.6.9c0 1.6-2.2 1.9-2.2 3.3" />
    <path d="M12 17.2h.01" />
  </Svg>
);

export const momentoIcon = { '🚗': IconCar, '💼': IconBriefcase, '🌎': IconQuake, '👶': IconBaby };

// Set de 21 · resuelve ícono por pantalla del wizard + valor de la ficha (journey1.json)
const TILE_ICONS = {
  momento: {
    'D1': IconCar, 'D5': IconHome, 'D3': IconBaby, 'D4': IconBriefcase, 'D2': IconQuake, 'Sin': IconShrug,
  },
  cuidar: {
    Auto: IconCar, Hogar: IconHome, Salud: IconHealth, 'Vida / ingresos': IconIncome, Educativo: IconEdu, Dispositivos: IconDevice,
  },
  quienes: {
    'Sin dependientes': IconSelf, Pareja: IconCouple, Hijos: IconKids, Padres: IconParents,
  },
  yapaga: {
    'Crédito con póliza incluida': IconBank, 'Seguros de la tarjeta': IconCard, 'Cobertura corporativa': IconBuilding, 'Por auditar con el asesor': IconUnknown,
  },
};

export const tileIcon = (screenKey, value) => {
  const map = TILE_ICONS[screenKey] || {};
  if (screenKey === 'momento') {
    const v = String(value);
    return (v.startsWith('D') ? map[v.slice(0, 2)] : map['Sin']) || IconShrug;
  }
  return map[value] || IconShield;
};
